import React, { useState, useEffect, useMemo, useCallback } from 'react';
import {
  formatDateMonth,
  KTSVG,
  LoadingGrid,
  toAbsoluteUrl,
} from '../../../../_mexablock/helpers';
import { TableList } from '../../../../_mexablock/helpers/components/TableList';
import { CreateModal } from '../_modals/CreateModal';
import { UpdateModal } from '../_modals/UpdateModal';
import { useGetAll } from '../hooks/DistribuidorHook';
import { ConfirmModal } from '../_modals/ConfirmModal';
import { MenuComponent } from '../../../../_mexablock/assets/ts/components';

const View: React.FC = () => {
  const [loadingView, setloadingView] = useState(true);
  const [visivilityModal, setVisivilityModal] = useState(false);
  const [dataUpdModal, setDataUpdModal] = useState();
  const [dataActModal, setDataActModal] = useState<number>(0);
  const [visivilityModalUpd, setVisivilityModalUpd] = useState<boolean>(false);
  const [visivilityModalAct, setVisivilityModalAct] = useState<boolean>(false);
  const [reloadGrid, setReloadGrid] = useState(1);
  const [initFilterValues] = useState({
    nombre: '',
  });
  const { data, loadingRequest } = useGetAll(reloadGrid, initFilterValues);

  useEffect(() => {
    if (loadingRequest > 0) {
      setloadingView(false);
    }
  }, [loadingRequest]);

  // Reinicializar menú cuando cambian los datos
  useEffect(() => {
    if (data && data.length > 0) {
      const timer = setTimeout(() => {
        MenuComponent.reinitialization();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [data]);

  const addRegister = useCallback(() => {
    setVisivilityModal((prev) => !prev);
  }, []);

  const updRegister = useCallback((row: any) => {
    setDataUpdModal(row);
    setVisivilityModalUpd(true);
  }, []);

  const actRegister = useCallback((id: number) => {
    setDataActModal(id);
    setVisivilityModalAct(true);
  }, []);

  const reloadData = useCallback(() => {
    setReloadGrid((prev) => prev + 1);
  }, []);

  const imageRender = useCallback(
    (user: any) => (
      <div className="symbol symbol-40px me-5">
        <img
          src={
            user.profile_photo
              ? `${process.env.REACT_APP_PUBLIC}users/${user.profile_photo}`
              : toAbsoluteUrl('/media/avatars/blank.png')
          }
          crossOrigin="anonymous"
          alt=""
        />
      </div>
    ),
    [],
  );

  const dropdownRender = useCallback(
    (row: any) => (
      <div className="d-flex justify-content-end flex-shrink-0">
        <a
          href="#/"
          data-kt-menu="true"
          className="btn btn-light btn-active-light-primary btn-sm"
          data-kt-menu-trigger="click"
          data-kt-menu-placement="bottom-end"
        >
          Acciones
        </a>

        <div
          className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4"
          data-kt-menu="true"
        >
          <div className="menu-item px-3">
            <a
              className="menu-link px-3"
              href="#/"
              onClick={() => updRegister(row)}
            >
              Editar
            </a>
          </div>
          {row.active && (
            <div className="menu-item px-3">
              <a
                className="menu-link px-3"
                data-kt-users-table-filter="delete_row"
                href="#/"
                onClick={() => actRegister(row.id)}
              >
                Deshabilitar
              </a>
            </div>
          )}
        </div>
      </div>
    ),
    [updRegister, actRegister],
  );

  const columns = useMemo(
    () => [
      {
        id: 'created_at',
        name: <div className="fw-bolder text-muted me-5">Fecha</div>,
        selector: (row: any) => formatDateMonth(row.created_at),
        sortable: true,
      },
      {
        id: 'contribuyente',
        name: <div className="fw-bolder text-muted me-5">Regimen</div>,
        selector: (row: any) => row.id_type_person,
        cell: (row: any) => (
          <span>{row.id_type_person === 1 ? 'Fisica' : 'Moral'}</span>
        ),
        sortable: true,
      },
      {
        id: 'business_name',
        name: (
          <div className="fw-bolder text-muted me-5">Nombre/Razón social</div>
        ),
        selector: (row: any) => row.name,
        sortable: true,
        sortFunction: (rowA: any, rowB: any) =>
          rowA.name.toLowerCase().localeCompare(rowB.name.toLowerCase()),
      },
      {
        id: 'encargado',
        name: <div className="fw-bolder text-muted me-5">Usuario</div>,
        selector: (row: any) =>
          `${row.createdBy.first_name} ${row.createdBy.father_last_name}`,
        sortable: true,
        sortFunction: (rowA: any, rowB: any) => {
          const fullNameA = `${rowA.createdBy.first_name} ${rowA.createdBy.father_last_name}`;
          const fullNameB = `${rowB.createdBy.first_name} ${rowB.createdBy.father_last_name}`;
          return fullNameA.localeCompare(fullNameB, 'es', {
            sensitivity: 'base',
          });
        },
      },

      {
        id: 'active',
        name: <div className="fw-bolder text-muted me-5">Estatus</div>,
        cell: (row: any) => (
          <span
            className={`badge py-3 px-4 fs-7 badge-light-${row.active ? 'success' : 'warning'
              }`}
          >
            {row.active ? 'Activo' : 'Inactivo'}
          </span>
        ),
        sortable: false,
      },
      {
        id: 'acciones',
        name: <div className="fw-bolder text-muted me-5"></div>,
        cell: (row: any) => dropdownRender(row),
        sortable: false,
      },
    ],
    [imageRender, dropdownRender],
  );

  const handleCloseCreateModal = useCallback(
    (updateGrid: boolean) => {
      if (updateGrid) reloadData();
      setVisivilityModal(false);
    },
    [reloadData],
  );

  const handleCloseUpdateModal = useCallback(
    (updateGrid: boolean) => {
      if (updateGrid) reloadData();
      setVisivilityModalUpd(false);
    },
    [reloadData],
  );

  const handleCloseConfirmModal = useCallback(
    (updateGrid: boolean) => {
      if (updateGrid) reloadData();
      setVisivilityModalAct(false);
    },
    [reloadData],
  );

  return (
    <>
      <div className="row gy-5 g-xl-8">
        <div className="col-xl-12">
          <div className={`card card-xxl-stretch mb-5 mb-xl-12`}>
            <div className="card-header border-0 pt-5">
              {/* <Filter
                initFilterValues={initFilterValues}
                onCleanFilter={onCleanFilter}
                onSearchFilter={onSearchFilter}
              /> */}
              <div className="card-title align-items-start flex-column"></div>
              <div
                className="card-toolbar"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                data-bs-trigger="hover"
                title="Nuevo registro"
              >
                <a
                  href="#/"
                  className="btn btn-sm btn-light-primary"
                  id="kt_toolbar_primary_button"
                  onClick={addRegister}
                >
                  <KTSVG
                    path="/media/icons/duotune/arrows/arr075.svg"
                    className="svg-icon-5 svg-icon-gray-500 me-1"
                  />
                  Nuevo
                </a>
              </div>
            </div>
            {loadingView ? (
              <LoadingGrid text="Cargando..."></LoadingGrid>
            ) : (
              <TableList data={data} columns={columns}></TableList>
            )}
          </div>
        </div>
      </div>
      <CreateModal
        id_row={0}
        title=""
        show={visivilityModal}
        handleClose={handleCloseCreateModal}
      />
      <UpdateModal
        infoDis={dataUpdModal}
        show={visivilityModalUpd}
        handleClose={handleCloseUpdateModal}
      />
      <ConfirmModal
        id={dataActModal}
        show={visivilityModalAct}
        handleClose={handleCloseConfirmModal}
      />
    </>
  );
};

export { View };
